import './dropDownArrow.css'

export default function DropDownArrow() {
    return(
        <div className="drop-down-arrow">
            <svg width="25.569" height="14.618" viewBox="0 0 25.569 14.618">
                <path id="Icon_ion-ios-arrow-back" data-name="Icon ion-ios-arrow-back" d="M15.657,18.975l9.675-9.667a1.827,1.827,0,0,0-2.588-2.58L11.783,17.681a1.824,1.824,0,0,0-.053,2.52L22.736,31.23a1.827,1.827,0,0,0,2.588-2.58Z" transform="translate(-6.194 25.868) rotate(-90)" fill="#f8fdff"/>
            </svg>
        </div>
    )
}